<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton" [disabled]=vb.disabled></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Navigation</ion-title>
        <ion-buttons slot="end">
            <ion-button data-test="more" [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons>

        <!-- 
        <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
            <ion-button id="next" (click)="onNextClick()">
                <ion-icon name="arrow-forward"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary">
        Control Panel - (Step 4 of 5)
    </ion-list-header>

    <ion-list lines="none">
        <ion-item-divider color="tertiary">
            <ion-grid>
                <ion-row class="currentInfoHeader">
                    <ion-label class="ion-text-wrap">
                        <span class="line1">Current Ticket</span>
                    </ion-label>
                </ion-row>

                <ion-row> <!-- on the ion-label in the class put:  ion-padding  -->
                    @if (vm.currentLeg) {
                    <ion-label class="ion-text-wrap currentInfo" [class.urgent]="vm.currentLeg.isUrgent">
                        <span class="line1">Passenger: {{vm.currentLeg.passengerName}}</span><br />
                        <span class="line2">To: {{vm.currentLeg.to.location.locationName}}</span><br />
                        <!-- <span class="line2">Address1: {{vm.currentLeg.to.address1}}</span><br />
                            <span class="line2">Address2: {{vm.currentLeg.to.address2}}</span><br /> -->
                        <span class="line2">Distance: {{vm.distanceFromDestination.miles}} miles</span><br />
                        <span class="line2">Note: {{getNote(vm.currentLeg.ticketUid)}}</span><br />
                        @if (isDebugMode()) {
                            <div>
                                <span class="line2">legIndex: {{vm.currentLegIdx}}</span><br />
                                <span class="line2">Coordinate: {{getCurrentCoordinate()}}</span><br />
                                <!--
                                        <span class="line2">As of: {{asOf}}</span><br />
                                        <span class="line2">Near: {{nearAddress}}</span><br />
                                    -->
                            </div>
                        }
                    </ion-label>
                    }
                </ion-row>
            </ion-grid>
        </ion-item-divider>

        <ion-item>
            <ion-grid>
                <ion-row>
                    <ion-col>
                        <ion-button data-test="makeNextTicketCurrent" [disabled]=vb.disabled class="panelButton ion-text-wrap" expand="full"
                            (click)="onMakeNextTicketCurrentClick()">
                            Make Next Ticket Current
                        </ion-button>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col>
                        <!-- <ion-button class="panelButton ion-text-wrap" #startNav expand="full"
                                    (click)="onStartNavigationClick()">
                            Navigate To Current Ticket -->
                        <ion-button data-test="launchTurnByTurn" class="panelButton ion-text-wrap" expand="full" [disabled]="disableTurnByTurn()"
                            (click)="onStartNavigationClick()">
                            Launch Turn-By-Turn To Current Ticket
                        </ion-button>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col>
                        <ion-button data-test="completeCurrentTicket" class="panelButton ion-text-wrap" expand="full" (click)="onCompleteTicketClick()"
                            [disabled]="!vm.currentLeg">
                            Complete Current Ticket
                        </ion-button>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-item>
    </ion-list>
</ion-content>

<ion-footer>
    <a id="phoneCaller" target="_self"></a>

    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button data-test="nextButton" [disabled]=vb.disabled title="Next" (click)="onNextClick()">
            <ion-icon name="chevron-forward"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-footer>